// src/App.jsx
import "./styles.css";
import { Routes, Route, Navigate } from "react-router-dom";

// Public layout parts
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";


// Public pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import Blogs from "./pages/Blogs";
import BlogDetailPage from "./pages/BlogDetailPage";
import CaseStudies from "./pages/CaseStudies";
import CaseStudiesDetailPage from "./pages/CaseStudiesDetailPage";
import PlansPage from "./pages/PlansPage";
import SubscribeDetailsPage from "./pages/SubscribeDetailsPage";
import SubscribePaymentPage from "./pages/SubscribePaymentPage";
import SubscribeSuccessPage from "./pages/SubscribeSuccessPage";

// Route guards
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./components/RoleRoute";

// Admin layout + pages (ADMIN tree)
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import LawyersPage from "./modules/Admin/pages/LawyersPage";
import FirmsPage from "./modules/Admin/pages/FirmsPage";
import AdminProfilePage from "./modules/Admin/pages/AdminProfilePage";
import ServicesPage from "./modules/Admin/pages/ServicesPage";
import BlogPage from "./modules/Admin/pages/BlogPage";
import BlogCategoriesPage from "./modules/Admin/pages/BlogCategoriesPage";

import CaseStudyPage from "./modules/Admin/pages/CaseStudyPage";
import UserQueriesPage from "./modules/Admin/pages/UserQueriesPage";
import PackagesPage from "./modules/Admin/pages/PackagesPage";
import SubscriptionsPage from "./modules/Admin/pages/SubscriptionsPage";
import PartnerLogosPage from "./modules/Admin/pages/PartnerLogosPage";
import FaqsPage from "./modules/Admin/pages/FaqsPage";
import SocialLinksPage from "./modules/Admin/pages/SocialLinksPage";
import TestimonialsPage from "./modules/Admin/pages/TestimonialsPage";
import ChatPage from "./modules/Admin/pages/ChatPage";
import ServiceRequestsPage from "./modules/Admin/pages/ServiceRequestsPage";
import MeetingViewPage from "./modules/Admin/pages/MeetingViewPage";

// Firm layout + pages (FIRM tree)
import FirmLayout from "./firm/FirmLayout";
import FirmDashboard from "./firm/FirmDashboard";
import FirmLawyersPage from "./modules/Firm/pages/FirmLawyersPage";
import TeamPage from "./modules/Firm/pages/TeamPage";
import FirmServiceRequestsPage from "./modules/Firm/pages/ServiceRequestsPage";
import FirmChatPage from "./modules/Firm/pages/FirmChatPage";
import FirmProfilePage from "./modules/Firm/pages/FirmProfilePage";
import FirmMeetingViewPage from "./modules/Admin/pages/MeetingViewPage";

// Lawyer layout + pages (Lawyer tree)
import LawyerLayout from "./lawyer/LawyerLayout";
import LawyerDashboard from "./lawyer/LawyerDashboard";
import LawyerServiceRequestsPage from "./modules/Lawyer/pages/ServiceRequestsPage";
import LawyerChatPage from "./modules/Lawyer/pages/LawyerChatPage";
import LawyerProfilePage from "./modules/Lawyer/pages/LawyerProfilePage";
import LawyerMeetingViewPage from "./modules/Admin/pages/MeetingViewPage";

// Team layout + pages (Lawyer tree)
import TeamLayout from "./team/TeamLayout";
import TeamDashboard from "./team/TeamDashboard";
import TeamServiceRequestsPage from "./modules/Team/pages/ServiceRequestsPage";
import TeamChatPage from "./modules/Team/pages/TeamChatPage";
import TeamProfilePage from "./modules/Team/pages/TeamProfilePage";
import TeamMeetingViewPage from "./modules/Admin/pages/MeetingViewPage";
import { ConfigProvider, theme } from "antd";

export default function App() {
  return (
    <ConfigProvider
      theme={{
        // algorithm: darkAlgorithm,
        //type: 'dark',

        components: {
          Button: {
            primaryColor: "#fff",
            fontWeight: "600",
            contentFontSize: 16,
            defaultBorderColor: "#c7954a",
            defaultColor: "#c7954a",
            borderRadius: 25,
          },
          Form: {
            labelColor: "#000",
            labelFontSize: 16,
            labelTextAlign: "start",
          },
          Menu: {
            itemColor: "#c7954a",
            itemHoverBg: "#E6F3FF",
            itemHoverColor: "#c7954a",
            iconSize: 18,
          },
        },

        token: {
          // Seed Token
          colorPrimary: "#c7954a",
          borderRadius: 4,

          // Alias Token
          //colorBgContainer: '#324F94',
        },
      }}
    >
      <ScrollToTop />
      <WhatsAppButton />
      <Routes>
        {/* ---------- Public Routes ---------- */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <main className="cl-main">
                <Home />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/login"
          element={
            <>
              <Header />
              <main className="cl-main">
                <Login />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/contact"
          element={
            <>
              <Header />
              <main className="cl-main">
                <Contact />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/refund-policy"
          element={
            <>
              <Header />
              <main className="cl-main">
                <RefundPolicyPage />
              </main>
              <Footer />
            </>
          }
        />

        <Route path="/services" element={<Navigate to="/" replace />} />
        <Route path="/service-details/:id" element={<Navigate to="/" replace />} />

        <Route
          path="/blogs"
          element={
            <>
              <Header />
              <main className="cl-main">
                <Blogs />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/case-studies"
          element={
            <>
              <Header />
              <main className="cl-main">
                <CaseStudies />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/blogs/:id"
          element={
            <>
              <Header />
              <main className="cl-main">
                <BlogDetailPage />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/case-studies/:id"
          element={
            <>
              <Header />
              <main className="cl-main">
                <CaseStudiesDetailPage />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/plans/:type"
          element={
            <>
              <Header />
              <main className="cl-main">
                <PlansPage />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/subscribe/details"
          element={
            <>
              <Header />
              <main className="cl-main">
                <SubscribeDetailsPage />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/subscribe/payment/:token"
          element={
            <>
              <Header />
              <main className="cl-main">
                <SubscribePaymentPage />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/subscribe/success"
          element={
            <>
              <Header />
              <main className="cl-main">
                <SubscribeSuccessPage />
              </main>
              <Footer />
            </>
          }
        />

        {/* ---------- Admin Routes (/admin/*) ---------- */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* Default /admin → dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          {/* Shared (admin + lawyer) */}
          <Route
            path="dashboard"
            element={
              <RoleRoute allowed={["admin", "lawyer"]}>
                <AdminDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="services"
            element={
              <RoleRoute allowed={["admin", "lawyer"]}>
                <ServicesPage />
              </RoleRoute>
            }
          />
          <Route
            path="requests"
            element={
              <RoleRoute allowed={["admin", "lawyer"]}>
                <ServiceRequestsPage />
              </RoleRoute>
            }
          />
          <Route
            path="chats"
            element={
              <RoleRoute allowed={["admin", "lawyer"]}>
                <ChatPage />
              </RoleRoute>
            }
          />
          <Route
            path="meetings"
            element={
              <RoleRoute allowed={["admin"]}>
                <MeetingViewPage />
              </RoleRoute>
            }
          />

          {/* Admin-only */}
          <Route
            path="lawyers"
            element={
              <RoleRoute allowed={["admin"]}>
                <LawyersPage />
              </RoleRoute>
            }
          />

          <Route
            path="firms"
            element={
              <RoleRoute allowed={["admin"]}>
                <FirmsPage />
              </RoleRoute>
            }
          />
          <Route
            path="blogs"
            element={
              <RoleRoute allowed={["admin"]}>
                <BlogPage />
              </RoleRoute>
            }
          />
          <Route
            path="caseStudies"
            element={
              <RoleRoute allowed={["admin"]}>
                <CaseStudyPage />
              </RoleRoute>
            }
          />

          <Route
            path="category"
            element={
              <RoleRoute allowed={["admin"]}>
                <BlogCategoriesPage />
              </RoleRoute>
            }
          />          
          <Route
            path="queries"
            element={
              <RoleRoute allowed={["admin"]}>
                <UserQueriesPage />
              </RoleRoute>
            }
          />
          <Route
            path="packages"
            element={
              <RoleRoute allowed={["admin"]}>
                <PackagesPage />
              </RoleRoute>
            }
          />
          <Route
            path="subscriptions"
            element={
              <RoleRoute allowed={["admin"]}>
                <SubscriptionsPage />
              </RoleRoute>
            }
          />
          <Route
            path="logos"
            element={
              <RoleRoute allowed={["admin"]}>
                <PartnerLogosPage />
              </RoleRoute>
            }
          />
          <Route
            path="faqs"
            element={
              <RoleRoute allowed={["admin"]}>
                <FaqsPage />
              </RoleRoute>
            }
          />
          <Route
            path="social"
            element={
              <RoleRoute allowed={["admin"]}>
                <SocialLinksPage />
              </RoleRoute>
            }
          />
          <Route
            path="testimonials"
            element={
              <RoleRoute allowed={["admin"]}>
                <TestimonialsPage />
              </RoleRoute>
            }
          />
          <Route
            path="profile"
            element={
              <RoleRoute allowed={["admin"]}>
                <AdminProfilePage />
              </RoleRoute>
            }
          />
        </Route>

        {/* ---------- Firm Routes (/firm/*) ---------- */}
        <Route
          path="/firm/*"
          element={
            <ProtectedRoute>
              <FirmLayout />
            </ProtectedRoute>
          }
        >
          {/* Default /firm → dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route
            path="dashboard"
            element={
              <RoleRoute allowed={["firm"]}>
                <FirmDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="requests"
            element={
              <RoleRoute allowed={["firm"]}>
                <FirmServiceRequestsPage />
              </RoleRoute>
            }
          />
          {/* <Route
          path="lawyers"
          element={
            <RoleRoute allowed={["firm"]}>
              <FirmLawyersPage />
            </RoleRoute>
          }
        /> */}
          <Route
            path="teams"
            element={
              <RoleRoute allowed={["firm"]}>
                <TeamPage />
              </RoleRoute>
            }
          />
          <Route
            path="chats"
            element={
              <RoleRoute allowed={["firm"]}>
                <FirmChatPage />
              </RoleRoute>
            }
          />
          <Route
            path="meetings"
            element={
              <RoleRoute allowed={["firm"]}>
                <FirmMeetingViewPage />
              </RoleRoute>
            }
          />
          <Route
            path="firmProfile"
            element={
              <RoleRoute allowed={["firm"]}>
                <FirmProfilePage />
              </RoleRoute>
            }
          />
        </Route>

        {/* ---------- Lawyer Routes (/lawyer/*) ---------- */}
        <Route
          path="/lawyer/*"
          element={
            <ProtectedRoute>
              <LawyerLayout />
            </ProtectedRoute>
          }
        >
          {/* Default /lawyer → dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route
            path="dashboard"
            element={
              <RoleRoute allowed={["lawyer"]}>
                <LawyerDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="requests"
            element={
              <RoleRoute allowed={["lawyer"]}>
                <LawyerServiceRequestsPage />
              </RoleRoute>
            }
          />

          <Route
            path="chats"
            element={
              <RoleRoute allowed={["lawyer"]}>
                <LawyerChatPage />
              </RoleRoute>
            }
          />
          <Route
            path="meetings"
            element={
              <RoleRoute allowed={["lawyer"]}>
                <LawyerMeetingViewPage />
              </RoleRoute>
            }
          />
          <Route
            path="lawyerProfile"
            element={
              <RoleRoute allowed={["lawyer"]}>
                <LawyerProfilePage />
              </RoleRoute>
            }
          />
        </Route>

        {/* ---------- Team Routes (/team/*) ---------- */}
        <Route
          path="/team/*"
          element={
            <ProtectedRoute>
              <TeamLayout />
            </ProtectedRoute>
          }
        >
          {/* Default /team → dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route
            path="dashboard"
            element={
              <RoleRoute allowed={["team"]}>
                <TeamDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="requests"
            element={
              <RoleRoute allowed={["team"]}>
                <TeamServiceRequestsPage />
              </RoleRoute>
            }
          />

          <Route
            path="chats"
            element={
              <RoleRoute allowed={["team"]}>
                <TeamChatPage />
              </RoleRoute>
            }
          />
          <Route
            path="meetings"
            element={
              <RoleRoute allowed={["team"]}>
                <TeamMeetingViewPage />
              </RoleRoute>
            }
          />
          <Route
            path="teamProfile"
            element={
              <RoleRoute allowed={["team"]}>
                <TeamProfilePage />
              </RoleRoute>
            }
          />
        </Route>

        {/* ---------- Fallback ---------- */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfigProvider>
  );
}
